import { render } from "./ButtonConfirmation.vue?vue&type=template&id=cfdac194&scoped=true&lang=pug"
import script from "./ButtonConfirmation.vue?vue&type=script&lang=ts"
export * from "./ButtonConfirmation.vue?vue&type=script&lang=ts"

import "./ButtonConfirmation.vue?vue&type=style&index=0&id=cfdac194&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cfdac194"

export default script